import { BittsFilterValue } from '@crossbeam/bitts/src/types';

import { InjectionKey, Reactive, Ref } from 'vue';

import { useRequiredFields } from '@/composables/useRequiredFields';
import { CloseDealsFilter } from '@/constants/deal_navigator';
import type { DealNavData } from '@/types/deal_navigator';
import type { OverlapsCacheFunctions } from '@/types/reports';

// Separate injection keys for each table
export const ProvidedCloseDealsFiltersStateKey: InjectionKey<
  Reactive<Record<string, BittsFilterValue | undefined>>
> = Symbol('ProvidedCloseDealsFilterStateKey');

export const ProvidedCloseDealsSearchStateKey: InjectionKey<Ref<string>> =
  Symbol('ProvidedCloseDealsSearchStateKey');

export const ProvidedGenPipeFiltersStateKey: InjectionKey<
  Reactive<Record<string, BittsFilterValue | undefined>>
> = Symbol('ProvidedGenPipeFiltersStateKey');

export const ProvidedGenPipeSearchStateKey: InjectionKey<Ref<string>> = Symbol(
  'ProvidedGenPipeSearchStateKey',
);

export const ProvidedDealNavigatorRequiredFieldsRefKey: InjectionKey<
  Reactive<ReturnType<typeof useRequiredFields>>
> = Symbol('ProvidedDealNavigatorRequiredFieldsRefKey');

export const ProvidedIsGenPipe: InjectionKey<Ref<boolean>> =
  Symbol('ProvidedIsGenPipe');

export type DrawerContextType = 'close-deals' | 'gen-pipe' | 'list';
export const ProvidedDrawerContext: InjectionKey<Ref<DrawerContextType>> =
  Symbol('ProvidedDrawerContext');

export const ProvidedDealNavPartnerFilters: InjectionKey<
  Ref<{
    [CloseDealsFilter.PARTNERS]: string[];
    [CloseDealsFilter.PARTNER_TAGS]: string[];
  }>
> = Symbol('ProvidedDealNavPartnerFilters');

export const ProvidedDealNavData: InjectionKey<Ref<DealNavData>> = Symbol(
  'ProvidedDealNavData',
);

export const ProvidedOverlapsCache: InjectionKey<OverlapsCacheFunctions> =
  Symbol('ProvidedOverlapsCache');
